/**
 * Composable для работы с аутентификацией
 * Удобная обертка над auth store
 */
import { storeToRefs } from 'pinia'
import { useAuthStore } from '../stores/auth.store'

export const useAuth = () => {
  const authStore = useAuthStore()
  
  // Reactive refs from store
  const {
    user,
    isAuthenticated,
    isLoading,
    error,
    authState
  } = storeToRefs(authStore)
  
  // Actions
  const {
    login,
    logout,
    refreshToken,
    initialize,
    clearError
  } = authStore
  
  return {
    // State
    user,
    isAuthenticated,
    isLoading,
    error,
    authState,
    
    // Actions
    login,
    logout,
    refreshToken,
    initialize,
    clearError
  }
}
